import { HttpContextToken } from '@angular/common/http';

export const CTX_SHOW_SPINNER = new HttpContextToken<boolean>(() => true);
export const CTX_TOAST_ERRORS = new HttpContextToken<boolean>(() => true);
export const CTX_ATTACH_CUSTOM_HEADERS = new HttpContextToken<boolean>(() => true);
